import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AccountService } from "../models/account.service";

@Injectable()
export class PlanTierService {
  // Attributes (search filters & aggregations) available on T1 (free) tier.
  private BASIC_ATTRS = [
    "resolved",
    "errors.0.message",
    "context.component",
    "context.action",
    "context.environment",
    "start_time",
    "end_time",
    "on",
    "muted",
    "has_comments",
  ];

  constructor(private accountService: AccountService) {}

  public tier() {
    return this.accountService
      .properties()
      .pipe(map((props: any) => props.account.plan_tier));
  }

  public features() {
    return this.accountService
      .properties()
      .pipe(map((props: any) => props.plan));
  }

  public isBasicAttr(attr: any) {
    return this.BASIC_ATTRS.indexOf(attr.key) !== -1;
  }

  public allowsAggregationAttr(attr: any, features: any) {
    if (features.advanced_aggregations) {
      return true;
    }
    return this.isBasicAttr(attr);
  }

  public allowsSearchAttr(attr: any, features: any) {
    if (features.custom_search) {
      return true;
    } else if (features.advanced_search) {
      return !attr.custom;
    } else {
      return this.isBasicAttr(attr);
    }
  }
}
